import { httpClient, apiLinks } from '@app/utils';
import { DataLogs, ParamsGetLogs } from '../models/log';

const getLogs = async (params: ParamsGetLogs): Promise<DataLogs> => {
  const result = await httpClient.get<DataLogs>({
    url: apiLinks.admin.logManagement.getLog,
    params,
  });
  return result.data;
};

const customerService = {
  getLogs,
};

export default customerService;
